<template>
<div>
   <v-card class="mx-auto mt-5" width="1000">
     <v-app-bar color="primary" dark>
      <v-toolbar-title>{{ cardTitle }}</v-toolbar-title>
      <v-spacer/>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="検索" single-line hide-details></v-text-field>
     </v-app-bar>
      <v-data-table :headers="headers" :items="jobs" :search="search" class="mt-3">
        <template v-slot:[`item.jobClass`]="{ item }">
          <!-- グループIDの有無から分類を表示する -->
          {{ dispJobClass(item) }}
        </template>
        <template v-slot:[`item.jobName`]="{ item }">
          <router-link style="text-decoration: none;" :to="dispJobDetailLink(item)">
            <span>{{ item.jobName }}</span>
          </router-link>
        </template>
        <template v-slot:[`item.categoryList`]="{ item }">
          <v-chip v-for="category in item.categoryList" :key="category.id" color="accent" class="ml-1 my-1" small outlined>
            {{ category.name }}
          </v-chip>
        </template>
        <template v-slot:[`item.jobContinueCount`]="{ item }">
          {{ dispJobContinueCount(item) }}
        </template>
        <template v-slot:[`item.jobTargetCount`]="{ item }">
          {{ dispJobTargetCount(item) }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          {{ dispJobStatus(item) }}
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <div v-show="checkIsAuthorized(item)">
            <v-icon @click="editJob(item)" small class="mr-2">mdi-pencil</v-icon>
            <v-icon @click="deleteJob(item)" small class="mr-2">mdi-delete</v-icon>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <!-- ジョブ登録フォーム表示用ボタン -->
    <v-fab-transition v-if="isLoginUser">
      <v-btn @click.stop="toggleJobFormModal" color="accent" absolute right fixed fab x-large class="mb-5" 
        style="right:30px;bottom:50px;">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>
    <!-- ジョブフォームモーダル -->
    <v-dialog v-model=jobFormModal width="600" persistent>
      <job-form-component @close="closeModal" :edit-job="job" :form="form"/>
    </v-dialog>
    <!-- グループジョブフォームモーダル -->
    <v-dialog v-model=$store.state.groupJobFormModal width="600" persistent>
      <group-job-form-component @close="closeModal" :edit-group-job="groupJob" :group="group" :form="form"/>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import jobFormComponent from '@/components/JobForm.vue'
import groupJobFormComponent from '@/components/GroupJobForm.vue'
export default {
  name: 'JobListComponent',
  components: {
    jobFormComponent,
    groupJobFormComponent
  },
  created(){
    if(this.$route.params.user_id) this.fetchOtherUserJobs(this.$route.params.user_id);
  },
  data() {
    return {
      isLoginUser: !this.$route.params.user_id,
      jobFormModal: false,
      groupJobFormModal: false,
      form: {},
      search: '',
      job: {},
      groupJob: {},
      group: {},
    }
  },
  computed: {
    jobs(){
      return this.isLoginUser ? this['job/myJobs'] : this['job/otherUserJobs'];
    },
    cardTitle() {
      return this.isLoginUser ? 'マイジョブ一覧' : 'ジョブ一覧'
    },
    // ログインユーザーか否かで表示するカラムを変更する
    headers(){
      return this.isLoginUser ? [
        { text: '分類', align: 'center', sortable: true, value: 'jobClass', width: '10%'},
        { text: 'ジョブ名', align: 'center', sortable: true, value: 'jobName', width: '28%'},
        { text: 'カテゴリー', align: 'center', sortable: false, value: 'categoryList', width: '22%'},
        { text: '現在回数', align: 'center', sortable: true, value: 'jobContinueCount', width: '12%'},
        { text: '目標回数', align: 'center', sortable: true, value: 'jobTargetCount', width: '10%'},
        { text: '状態', align: 'center', sortable: false, value: 'status', width: '9%'},
        { text: '操作', align: 'center', sortable: false, value: 'action', width: '9%'},
      ] : [
        { text: '分類', align: 'center', sortable: true, value: 'jobClass', width: '10%'},
        { text: 'ジョブ名', align: 'center', sortable: true, value: 'jobName', width: '27%'},
        { text: 'カテゴリー', align: 'center', sortable: false, value: 'categoryList', width: '33%'},
        { text: '現在回数', align: 'center', sortable: true, value: 'jobContinueCount', width: '10%'},
        { text: '目標回数', align: 'center', sortable: true, value: 'jobTargetCount', width: '10%'},
        { text: '状態', align: 'center', sortable: false, value: 'status', width: '10%'},
      ];
    },
    ...mapGetters(['loginUserId', 'job/myJobs', 'job/otherUserJobs'])
  },
  methods:{
    toggleJobFormModal(){
      this.job = {};
      this.form = { title: 'ジョブ作成', subTitle: '個人で行うジョブを作成することができます', buttonText: '作成'};
      this.jobFormModal = !this.jobFormModal;
    },
    closeModal(){
      this.jobFormModal = false;
      this.groupJobFormModal = false;
    },
    dispJobClass(job){
      return job.groupId ? 'グループ' : '個人';
    },
    dispJobContinueCount(job){
      return job.memberList.reduce((prev, current) => prev + current.jobContinueCount, 0)
    },
    dispJobTargetCount(job){
      return job.jobTargetContinueCount ? job.jobTargetContinueCount : job.jobTargetTotalCount;
    },
    dispJobStatus(job){
      switch(job.jobStatus){
        case 1:
          return '継続中'
        case 2:
          return '達成'
        case 3:
          return '失敗'
        case 9:
          return '無効'
      }
    },
    dispJobDetailLink(job){
      const jobId = job.jobId
      return !job.groupId ? {name: 'JobDetail', params: { 'job_id': jobId }} 
                                : { name: 'GroupJobDetail', params: { 'job_id': jobId }}
    },
    checkIsAuthorized(job){
      const user = job.memberList.find(member => member.userId === this.loginUserId);
      return user ? user.isAuthorized : false;
    },
    editJob(item){
      if(!item.groupId){
        this.job = item;
        this.form = {
          title: 'ジョブ編集',
          subTitle: '個人で行うジョブを作成することができます',
          buttonText: '更新'};
        this.jobFormModal = true;
      } else {
        this.groupJob = item;
        this.form = {
          title: 'グループジョブ編集',
          subTitle: '同じ目的を持つメンバーと一緒にジョブを実施することができます',
          buttonText: '更新'};
        this.$store.state.groupJobFormModal  = !this.$store.state.groupJobFormModal 
      }
    },
    deleteJob(item){
      if(confirm(`ジョブ「${item.jobName}」を削除しますか？`)){
        item.jobStatus = 9; // 無効
        this.updateMyJob(item)
      }
    },
    ...mapActions('job', ['fetchMyJobs', 'updateMyJob', 'fetchOtherUserJobs'])
  }
}
</script>